import React from "react";
import { Button } from "reactstrap";
import { FA } from "components/FA";
import { openNoteFormModal } from "components/personal";
import {
  ResponseType,
  ResponseTypeLabel,
  ResponseTypeIcons,
  DataSourceLabel,
  DataSourceIcons,
} from "data/Types";
import { useResponses } from "hooks";

const ResponseActions = ({
  response,
  className,
  handleClose,
  detail,
  personal,
  web,
}) => {
  const { responseIds, actions } = useResponses();
  const isSaved = responseIds.includes(response.id);
  return (
    <div className={className}>
      <Button size="sm" color="link" disabled>
        <FA icon={ResponseTypeIcons[response.responseType]} />{" "}
        {ResponseTypeLabel[response.responseType]}
      </Button>
      {response.dataSource && DataSourceIcons[response.dataSource] && (
        <Button size="sm" color="link" disabled>
          <FA icon={DataSourceIcons[response.dataSource]} />{" "}
          {DataSourceLabel[response.dataSource]}
        </Button>
      )}
      {!web && (
        <Button
          size="sm"
          color="action"
          onClick={(e) => {
            e.stopPropagation();
            actions.response(response);
          }}
        >
          {isSaved ? (
            <>
              <FA icon="trash" /> remove
            </>
          ) : (
            <>
              <FA icon="star" /> save
            </>
          )}
        </Button>
      )}
      {personal && (
        <Button
          size="sm"
          color="action"
          onClick={(e) => {
            e.stopPropagation();
            openNoteFormModal(response.id);
          }}
        >
          <FA icon="comment" /> comment
        </Button>
      )}
      {personal && response.responseType === ResponseType.FILE && (
        <Button
          size="sm"
          color="action"
          onClick={(e) => {
            e.stopPropagation();
            actions.download(response.id, response.title);
          }}
        >
          <FA icon="download" /> download
        </Button>
      )}
      {!detail &&
        response.url &&
        response.url.map((url, i) => {
          let short = url;
          try {
            short = new URL(url).hostname;
          } catch (e) {
            console.error(url);
          }
          return (
            <Button
              key={`${response.id}-${i}`}
              size="sm"
              tag="a"
              color="link"
              target="_blank"
              href={url}
            >
              <FA icon="globe" /> {short}
            </Button>
          );
        })}
      {handleClose && <Button onClick={handleClose} close />}
    </div>
  );
};
export { ResponseActions };
